import React from 'react'
import "./Spinner.css"

const Spinner = () => {
  return (
    <div class="h-screen flex items-center justify-center">
      <div className='spinner'></div>
    </div>
  )
}

export default Spinner
